// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"4baf394b","275":"dfc3c2c4","711":"819103c8","787":"a54cc342","789":"6474b9ff"}[chunkId] + ".chunk.js";
};